// extracted by mini-css-extract-plugin
export default {"empty-frame-hidden":"iW60fIM___empty-frame-hidden","emptyFrameHidden":"iW60fIM___empty-frame-hidden"};